import * as React from 'react'
import Media from 'react-media'

import { BreadcrumbsRenderer } from '@thg-commerce/enterprise-components'
import {
  i18n,
  useSiteConfig,
  useSiteDefinition,
  useTheme,
} from '@thg-commerce/enterprise-core'
import { mq } from '@thg-commerce/gravity-theme'

import { useProductPage } from '../../context'

export const ProductBreadcrumbsRenderer = () => {
  const theme = useTheme()
  const homei18nText = i18n('general.breadcrumbs.home.text')
  const { selectedVariant, product } = useProductPage()
  const {
    PDPDisplayMasterProductTitle,
    showBackwardNavigationForBreadcrumbs,
    enableEllipsisBreadCrumbs,
    hideBreadcrumbsOnProductPage,
    enableFullBreadcrumbsOnMobile,
  } = useSiteConfig()
  const { originUrl } = useSiteDefinition()

  if (!product || hideBreadcrumbsOnProductPage) {
    return null
  }

  const variantBreadcrumbChecks =
    !PDPDisplayMasterProductTitle && selectedVariant

  const variantBreadcrumbs =
    variantBreadcrumbChecks && selectedVariant.breadcrumbs
      ? selectedVariant.breadcrumbs
      : product.breadcrumbs

  const homeLink =
    variantBreadcrumbs.length > 0 && variantBreadcrumbs[0].url === '/'

  const breadcrumbs = homeLink
    ? variantBreadcrumbs
    : [
        {
          text: homei18nText,
          url: originUrl,
        },
        ...variantBreadcrumbs,
      ]

  const variantBreadcrumbSchemaItems =
    variantBreadcrumbChecks && selectedVariant.breadcrumbSchemaItems
      ? selectedVariant.breadcrumbSchemaItems
      : product.breadcrumbSchemaItems

  const breadcrumbSchemaItems = (homeLink
    ? variantBreadcrumbSchemaItems
    : [
        {
          '@type': 'ListItem',
          position: 1,
          name: homei18nText,
          item: originUrl,
        },
        ...variantBreadcrumbSchemaItems,
      ]
  ).map((breadcrumb) => {
    delete breadcrumb['__typename']
    return { ...breadcrumb, '@type': 'ListItem' }
  })

  const breadCrumbsStyleOverride = {
    paddingBottom: theme.elements.breadCrumbs.list?.paddingBottom,
    overflow: theme.elements.breadCrumbs.list?.overflow,
  }

  return (
    <React.Fragment>
      <Media query={mq(theme.breakpointUtils.map, 'sm', true)}>
        {(isDesktop) => (
          <BreadcrumbsRenderer
            breadcrumbs={breadcrumbs}
            schemaItems={breadcrumbSchemaItems}
            enableBackButton={showBackwardNavigationForBreadcrumbs}
            originUrl={originUrl}
            styleOverride={breadCrumbsStyleOverride}
            isMobile={!isDesktop}
            ellipsis={{
              enabled: enableEllipsisBreadCrumbs,
              minNumberOfItems: 2,
              hideActiveLink: enableEllipsisBreadCrumbs && !isDesktop,
            }}
            forceDisplayBreadcrumbs={enableFullBreadcrumbsOnMobile ?? false}
          />
        )}
      </Media>
    </React.Fragment>
  )
}
